// AI usage service — fetches global and per-user token/cost metrics
import { fetchWithAuth } from '@startus/lib';
import type { AiUsageMetrics } from '../types/ai-usage';

const API_BASE_URL = import.meta.env.VITE_API_URL;

if (!API_BASE_URL) {
  throw new Error('VITE_API_URL is not defined');
}

/** Fetches AI usage metrics from GET /api/v1/admin/ai-usage */
export const fetchAiUsageData = async (): Promise<AiUsageMetrics> => {
  const response = await fetchWithAuth(`${API_BASE_URL}/api/v1/admin/ai-usage`, {
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch AI usage metrics: ${response.status}`);
  }

  // API wraps response in { success, data, meta } via TransformInterceptor
  const body = (await response.json()) as { data: AiUsageMetrics };
  return body.data;
};
